import { Injectable } from '@angular/core';
import {catchError, throwError} from 'rxjs';
import {environment} from "../../environments/environment";
import {HttpClient} from "@angular/common/http";

import {AtaskaitosParametraiApi} from '../api/ataskaitos-parametrai.api';

@Injectable({
  providedIn: 'root',
})
export class ReportService {
  private generateReportUrl = environment.apiBaseUrl + '/internalApi/generateReport';

  constructor(private http: HttpClient) {}

  generuotiAtaskaita(ataskaitosParametrai: AtaskaitosParametraiApi) {
    return this.http.post(this.generateReportUrl, ataskaitosParametrai, {
      withCredentials: true,
      responseType: 'blob', // This ensures the response is treated as a binary file
    }).pipe(
      catchError((error) => {
        return throwError(error);
      })
    );
  }
}
